import styled, { css } from 'styled-components';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var verticalLabelStyles = css(["flex-direction:column-reverse;align-items:center;"]);
var spacingFromSize = {
  small: 'spacing.md',
  medium: 'spacing.lg'
};
var Label = styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-5tv7qd-0"
})(["display:flex;justify-content:space-between;align-items:flex-start;gap:", ";padding:", ";border:", " solid ", ";border-radius:", ";background-color:", ";transition:all 0.1s;", ";", ";"], themeGet('spacing.md'), function (_ref) {
  var $size = _ref.$size;
  return themeGet(spacingFromSize[$size]);
}, pxToRem(1), themeGet('colors.border.100'), themeGet('borderRadius.md'), themeGet('colors.gray.0'), function (_ref2) {
  var $alignment = _ref2.$alignment;
  return $alignment === 'vertical' && verticalLabelStyles;
}, function (_ref3) {
  var $invalid = _ref3.$invalid;
  return css(["border-color:", ";&:hover:not(:has(input:disabled)){border-color:", ";box-shadow:", ";}&:has(input:checked){border-color:", ";background-color:", ";}&:has(input:focus-visible){border-color:", ";outline:", " solid ", ";box-shadow:", ";}&:has(input:active):not(:has(input:disabled)){border-color:", ";background-color:", ";box-shadow:", ";}&:has(input:disabled){opacity:0.5;box-shadow:none;}"], $invalid ? themeGet('colors.red.500') : themeGet('colors.border.100'), $invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000'), themeGet('dropShadow.400'), $invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000'), $invalid ? themeGet('colors.red.50') : themeGet('colors.primary.50'), $invalid ? themeGet('colors.focus.danger') : themeGet('colors.focus.primary'), pxToRem(3), $invalid ? themeGet('colors.focus.danger') : themeGet('colors.focus.primary'), themeGet('dropShadow.400'), $invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000'), $invalid ? themeGet('colors.red.100') : themeGet('colors.primary.100'), themeGet('dropShadow.400'));
});
var verticalInputStyles = css(["align-self:flex-end;"]);
var InputOverlay = styled.div.withConfig({
  displayName: "InputOverlay",
  componentId: "sc-5tv7qd-1"
})(["display:flex;justify-content:center;align-items:center;width:", ";height:", ";flex:0 0 ", ";background-color:", ";border:", " solid ", ";border-radius:", ";", ";", ""], pxToRem(20), pxToRem(20), pxToRem(20), themeGet('colors.background.50'), pxToRem(1), themeGet('colors.border.200'), function (_ref4) {
  var $type = _ref4.$type;
  return $type === 'radio' ? themeGet('borderRadius.circle') : themeGet('borderRadius.sm');
}, function (_ref5) {
  var $alignment = _ref5.$alignment;
  return $alignment === 'vertical' && verticalInputStyles;
}, function (_ref6) {
  var $invalid = _ref6.$invalid;
  return css(["input:checked + &{border-color:transparent;background-color:", ";}"], $invalid ? themeGet('colors.red.500') : themeGet('colors.primary.1000'));
});
var HiddenInput = styled.input.withConfig({
  displayName: "HiddenInput",
  componentId: "sc-5tv7qd-2"
})(["width:0;height:0;opacity:0;"]);

export { HiddenInput, InputOverlay, Label };
